import httpMethod from 'services/update2025/httpMethod';
import BlockDetail from "components/block-detail/BlockDetail";
import moment from "moment";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { findUserTransactions } from "services/UserTransactionService";
import { X_TOTAL_COUNT } from "utils/constants";
import { formatDate } from "utils/date";
import { handleError } from "utils/handleError";
import { UserTransactionContext } from "./UserTransactionContext";
import { UserTransactionEditor } from "./UserTransactionEditor";
export const UserTransactionList = () => {
    const toast = useRef(null);
    const dt = useRef(null);
    const { t, i18n } = useTranslation(["user-transaction", "common"]);
    const tokenObj = httpMethod.getTokenStorage(); // { access_token, … }
    const accessToken = tokenObj?.access_token;;

    let headers = {
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": i18n.language,
    };

    const userTransactionContext = useContext(UserTransactionContext);
    const { userTransaction, resetUserTransaction, setUserTransaction, userTransactions, setUserTransactions, submitted, setSubmitted, userTransactionDialog, setUserTransactionDialog } = userTransactionContext;

    const [loading, setLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [checkLoad, setCheckLoad] = useState(false);

    const requestStatuses = [
        { label: "Thành công", value: "SUCCESS" },
        { label: "Thất bại", value: "FAILURE" },
    ];

    const now = formatDate(new Date());

    const beforeNow = formatDate(new Date(new Date().setDate(new Date().getDate() - 5)));

    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 10,
        page: 0,
        filters: {
            username: { value: "", matchMode: "equals" },
            startDate: { value: beforeNow, matchMode: "equals" },
            endDate: { value: now, matchMode: "equals" },
            request: { value: "", matchMode: "equals" },
        },
    });

    const [globalFilter, setGlobalFilter] = useState(null);

    useEffect(() => {
        if (checkLoad) {
            loadLazyData();
            setCheckLoad(false);
        }
    }, [lazyParams]);

    const loadLazyData = () => {
        setLoading(true);

        findUserTransactions(headers, lazyParams)
            .then((res) => {
                setTotalRecords(res.headers[X_TOTAL_COUNT] ? parseInt(res.headers[X_TOTAL_COUNT]) : 0);
                const dataRes = res.data;
                dataRes?.forEach((e, i) => {
                    e.stt = lazyParams.rows * lazyParams.page + 1 + i;
                });
                setUserTransactions(dataRes);
            })
            .catch((error) => handleError(toast, t, error))
            .finally(() => setLoading(false));
    };

    const onPage = (event) => {
        setCheckLoad(true);
        let _lazyParams = { ...lazyParams, ...event };
        setLazyParams(_lazyParams);
    };

    const onSort = (event) => {
        setCheckLoad(true);
        let _lazyParams = { ...lazyParams, ...event };
        setLazyParams(_lazyParams);
    };

    const onFilter = (event) => {
        setCheckLoad(true);
        let _lazyParams = { ...lazyParams, ...event };
        _lazyParams["first"] = 0;
        setLazyParams(_lazyParams);
    };

    const openViewDialog = (userTransaction) => {
        setUserTransaction({ ...userTransaction });
        setUserTransactionDialog(true);
    };

    const textFilterTemplate = (options) => {
        return (
            <div className="flex align-items-center justify-content-center">
                <InputText value={options.value} onChange={(e) => options.filterApplyCallback(e.target?.value || "")} />
            </div>
        );
    };

    const requestStatusTemplate = (rowData) => {
        return <div className="flex align-items-center justify-content-center">{requestStatuses.find((e) => e.value === rowData.requestStatus)?.label}</div>;
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="flex align-items-center justify-content-center actions">
                <Button icon="pi pi-eye" className="p-button-rounded p-button mr-2" tooltip={t("view", { ns: "common" })} onClick={() => openViewDialog(rowData)} />
            </div>
        );
    };

    const paginatorTemplate = {
        layout: "RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink",
        RowsPerPageDropdown: (options) => {
            const dropdownOptions = [
                { label: 10, value: 10 },
                { label: 20, value: 20 },
                { label: 30, value: 30 },
                { label: 50, value: 50 },
            ];

            return (
                <React.Fragment>
                    <div style={{ width: "140px", display: "inline-block" }}>
                        <span className="mx-1">{t("show", { ns: "common" })}: </span>
                        <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
                    </div>
                </React.Fragment>
            );
        },
        CurrentPageReport: (options) => {
            return <span style={{ width: "calc(100% - 490px)", textAlign: "center", display: "inline-block" }}>{t("total", { ns: "common", total: options.totalRecords })}</span>;
        },
    };

    const searchOption = (
        <div className="grid">
            {/* tên truy cập */}
            <div className="col-12 md:col-3">
                <div className="grid custom-form">
                    <label
                        className="col-fixed text-center"
                        style={{
                            width: "130px",
                            // justifyContent: "end",
                            display: "flex",
                            padding: "0.75rem 0px 0px 0px",
                        }}
                        htmlFor="username"
                    >
                        {t("user-transaction.username")}
                    </label>
                    <div className="col">
                        <InputText
                            style={{
                                width: "100%",
                            }}
                            id="username"
                            name="username"
                            onChange={(e) => {
                                setCheckLoad(false);
                                setLazyParams({
                                    ...lazyParams,
                                    filters: {
                                        ...lazyParams.filters,
                                        username: {
                                            ...lazyParams.filters.username,
                                            value: e.target.value,
                                        },
                                    },
                                });
                            }}
                        ></InputText>
                    </div>
                </div>
            </div>

            {/* thời gian từ ngày*/}
            <div className="col-12 md:col-3">
                <div className="grid custom-form">
                    <label
                        className="col-fixed text-center"
                        style={{
                            width: "100px",
                            // justifyContent: "end",
                            display: "flex",
                            padding: "0.75rem 0px 0px 0px",
                        }}
                        htmlFor="startDate"
                    >
                        {t("user-transaction.startDate")} <small className="text-danger">*</small>
                    </label>
                    <div className="col">
                        <InputText
                            style={{
                                width: "100%",
                            }}
                            type="date"
                            id="startDate"
                            name="startDate"
                            value={lazyParams.filters.startDate.value}
                            max={lazyParams.filters.endDate.value}
                            onChange={(e) => {
                                setCheckLoad(false);
                                setLazyParams({
                                    ...lazyParams,
                                    filters: {
                                        ...lazyParams.filters,
                                        startDate: {
                                            ...lazyParams.filters.startDate,
                                            value: e.target.value,
                                        },
                                    },
                                });
                            }}
                        ></InputText>
                    </div>
                </div>
            </div>

            {/* đến  */}
            <div className="col-12 md:col-3">
                <div className="grid custom-form">
                    <label
                        className="col-fixed text-center"
                        style={{
                            width: "80px",
                            // justifyContent: "end",
                            display: "flex",
                            padding: "0.75rem 0px 0px 0px",
                        }}
                        htmlFor="endDate"
                    >
                        {t("user-transaction.endDate")} <small className="text-danger">*</small>
                    </label>
                    <div className="col">
                        <InputText
                            style={{
                                width: "100%",
                            }}
                            type="date"
                            id="endDate"
                            name="endDate"
                            value={lazyParams.filters.endDate.value}
                            max={now}
                            min={lazyParams.filters.startDate.value}
                            onChange={(e) => {
                                setCheckLoad(false);
                                setLazyParams({
                                    ...lazyParams,
                                    filters: {
                                        ...lazyParams.filters,
                                        endDate: {
                                            ...lazyParams.filters.endDate,
                                            value: e.target.value,
                                        },
                                    },
                                });
                            }}
                        ></InputText>
                    </div>
                </div>
            </div>

            <div className="col-12 md:col-3 text-right">
                <div className="grid custom-form">
                    <div className="col-12">
                        <label
                            style={{
                                // width: "130px",
                                // justifyContent: "end",
                                display: "flex",
                                padding: "0.75rem 0px 0px 0px",
                            }}
                        >
                            {" "}
                        </label>
                    </div>
                    <div className="col-12" style={{ margin: "5px 0px 0px 0px" }}>
                        <Button
                            label={t("search", { ns: "common" })}
                            icon="pi pi-search"
                            onClick={(e) => {
                                if (lazyParams.filters.startDate.value && lazyParams.filters.endDate.value) {
                                    setCheckLoad(true);
                                    setLazyParams({
                                        ...lazyParams,
                                        first: 0,
                                        page: 0,
                                    });
                                } else {
                                    toast.current.show({ severity: "info", summary: t("info", { ns: "common" }), detail: t("user-transaction.requiredfromandtodate"), life: 3000 });
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );

    const templateRequestDate = (rowData) => {
        if (rowData.requestTime) {
            return <div className="flex align-items-center justify-content-center actions">{moment(rowData.requestTime).format("DD/MM/YYYY HH:mm:ss")}</div>;
        }
        return null;
    };

    return (
        <div className="grid crud">
            <div className="col-12">
                <div className="card">
                    <div className="grid">
                        <div className="col-12">
                            <h4 className="text-center font-bold">{t("user-transaction.title")?.toUpperCase()}</h4>
                        </div>
                    </div>
                    <div className="grid">
                        <div className="col-12">
                            <BlockDetail title={t("search", { ns: "common" })}>{searchOption}</BlockDetail>
                        </div>
                    </div>

                    <div className="grid">
                        <div className="col-12">
                            <BlockDetail title={t("user-transaction.list")}>
                                <Toast ref={toast} />
                                <DataTable
                                    ref={dt}
                                    value={userTransactions}
                                    dataKey="id"
                                    className="datatable-responsive p-datatable-sm"
                                    showGridlines
                                    lazy
                                    paginator
                                    rows={lazyParams.rows}
                                    first={lazyParams.first}
                                    totalRecords={totalRecords}
                                    onPage={onPage}
                                    onSort={onSort}
                                    sortField={lazyParams.sortField}
                                    sortOrder={lazyParams.sortOrder}
                                    onFilter={onFilter}
                                    filters={lazyParams.filters}
                                    loading={loading}
                                    paginatorClassName="justify-content-start"
                                    paginatorTemplate={paginatorTemplate}
                                    emptyMessage="Không có dữ liệu"
                                    scrollable
                                >
                                    <Column field="stt" header={t("stt", { ns: "common" })} style={{ maxWidth: "50px" }} />
                                    <Column field="username" header={t("user-transaction.username")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />

                                    <Column field="content" sortable header={t("user-transaction.request")} style={{ minWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />

                                    <Column field="requestTime" header={t("user-transaction.requestTime")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />

                                    <Column field="requestStatus" header={t("user-transaction.requestStatus")} body={requestStatusTemplate} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />

                                    <Column field="userIpAddress" header={t("user-transaction.userIpAddress")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />

                                    <Column field="deviceName" header={t("user-transaction.deviceName")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />

                                    <Column body={actionBodyTemplate} style={{ maxWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                </DataTable>
                            </BlockDetail>
                        </div>
                    </div>
                    <UserTransactionEditor />
                </div>
            </div>
        </div>
    );
};
